import { render } from "./ChartTableSwitch.vue?vue&type=template&id=5684884e"
import script from "./ChartTableSwitch.vue?vue&type=script&lang=js"
export * from "./ChartTableSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__